
define(
	'TavanoTeam.DoubleUnitSales.DoubleUnitSales'
,   [
		'DoubleUnitSales.View',
		'ProductDetails.Base.View',
		'TavanoTeam.DoubleUnitSales.Submit.View',
		'ProductDetails.Information.View',
		'ProductViews.Price.View',
		'QuantityPricing.View',
		'ProductDetails.Full.View',
		'ProductDetails.QuickView.View',
		'Header.MiniCartItemCell.View',
		'tavanoteam_product_views_price.tpl',
		'product_details_information_extension.tpl',
		'product_details_full_extension.tpl',
		'product_details_quickview_extension.tpl',
		'SC.Configuration',
		'underscore'
		]
,   function (
		DoubleUnitSalesView,
		ProductDetailsBaseView,
		TavanoTeamDoubleUnitSalesSubmitView,
		ProductDetailsInformationView,
		ProductViewsPriceView,
		QuantityPricingView,
		ProductDetailsFullView,
		ProductDetailsQuickView,
		HeaderMiniCartItemCellView,
		tavanoteam_product_views_price_tpl,
		product_details_information_extension,
		product_details_full_extension_tpl,
		product_details_quickview_extension_tpl,
		Configuration,
		_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');
			var pdp = container.getComponent('PDP');
			var cart = container.getComponent("Cart");
			var environment = container.getComponent('Environment');

			//Get Configuration - Discontinued Items
			var itemMasterStatusArray = [
				"MANUFACTURER DISCONTINUED - Online - Active to Sell Stock Only",
				"MANUFACTURER DISCONTINUED - Display on Web"
				];
	
			var itemMasterStatusConfig = environment.getConfig("TTPDPHideWishlist.itemMasterStatus") || itemMasterStatusArray;

			//Get Configuration - Hazmat Items
			var hazmatDisclaimerPDPMessage = environment.getConfig("TTPDPHazmatItems.hazmatDisclaimerPDPMessage") || "Notice: Hazardous chemicals and products will incur additional Hazmat Fees and/or mandatory shipment via LTL Motor Freight";
			
			//Get Configuration - Order and Product Policies
			var orderAndProductPoliciesPDPMessage = environment.getConfig("TTPDPOrderAndProductPolicies") || false;

			//Get Configuration - Made to Order Disclaimer Message
			var madeToOrderDisclaimerMessage = environment.getConfig("TTPDPOrderAndProductPolicies.madeToOrderDisclaimerMessage") || "This is a MADE TO ORDER item. Per the manufacturer, orders cannot be canceled or returned. By ordering, you confirm that this cannot be canceled or returned.";
			var madeToOrderDisclaimerMessageEnable = environment.getConfig("TTPDPOrderAndProductPolicies.madeToOrderDisclaimerMessage.enable") || true;
			//End of Get Configuration - Made to Order Disclaimer Message

			//Hide Add Wishlist Button for Discontinued Items
			pdp.addToViewContextDefinition(pdp.PDP_FULL_VIEW, 'hideAddToWishlist', 'boolean', function(context){

				var isHide = false;
				var isDiscontinued = false;

				if (itemMasterStatusConfig) {

					var iteminfo = pdp.getItemInfo();
					var itemMasterStatus = iteminfo.item.custitem_item_master_status;

					//If Item is Discontinued
					isDiscontinued = itemMasterStatusConfig.indexOf(itemMasterStatus) !== -1;

					if (isDiscontinued) {
						isHide = true;
					} else {
						isHide = false;
					}

				}

				return isHide;	

			});


			if(layout)
			{
				layout.addChildView('Product.Price', function() { 
					return new DoubleUnitSalesView({ 
						container: container,
						pdp: pdp
					 });
				});
				layout.addChildView('Product.Stock.Info', function() { 
					return new TavanoTeamDoubleUnitSalesSubmitView({ 
						container: container,
						cart: cart,
						pdp: pdp
					 });
				});
			}

			_.extend(ProductDetailsBaseView.prototype, {
				getContext: _.wrap(ProductDetailsBaseView.prototype.getContext, function wrapInitialize(fn) {
					var ret = fn.apply(this, _.toArray(arguments).slice(1));
					ret.isPriceEnabled = false;
					try {
                        ret.pageHeader = ret.model.get('item').get('storedescription');
                    }catch(e){
						console.log(e);
					}
					return ret;
				})
			});

			_.extend(ProductViewsPriceView.prototype,{
				initialize: _.wrap(ProductViewsPriceView.prototype.initialize, function (fn, options) {
					var ret = fn.apply(this, _.toArray(arguments).slice(1));
					
					this.template = tavanoteam_product_views_price_tpl;
					return ret;
				}),
			});

			_.extend(ProductDetailsInformationView.prototype,{
				initialize: _.wrap(ProductDetailsInformationView.prototype.initialize, function (fn, options) {
					var ret = fn.apply(this, _.toArray(arguments).slice(1));
					this.template = product_details_information_extension;
					return ret;
				}),
				computeDetailsArea: function() {
					var self = this;
					var details = [];
						
					_.each(Configuration.get('productDetailsInformation', []), function(item_information) {
						var content = '';

						if (item_information.contentFromKey) {
							content = self.model.get('item').get(item_information.contentFromKey);
						}

						var itemAtt = self.model.get('item').attributes;
						
						var sdsUrl = itemAtt.custitem_spe_sds_url ? itemAtt.custitem_spe_sds_url : itemAtt.custitem_safety_data_sheet;
						var datasheetUrl = itemAtt.custitem_spe_product_datasheet_url ? itemAtt.custitem_spe_product_datasheet_url : itemAtt.custitem_spe_product_datasheet;
						var manualUrl = itemAtt.custitem_spe_product_manual_url ? itemAtt.custitem_spe_product_manual_url : itemAtt.custitem_spe_product_manual;
						var video = itemAtt.custitem_spe_product_videos;
						
						var bullets = [];
						itemAtt.custitem_web_bullet1 ? bullets.push({name: itemAtt.custitem_web_bullet1}) : '';
						itemAtt.custitem_web_bullet2 ? bullets.push({name: itemAtt.custitem_web_bullet2}) : '';
						itemAtt.custitem_web_bullet3 ? bullets.push({name: itemAtt.custitem_web_bullet3}) : '';
						itemAtt.custitem_web_bullet4 ? bullets.push({name: itemAtt.custitem_web_bullet4}) : '';
						itemAtt.custitem_web_bullet5 ? bullets.push({name: itemAtt.custitem_web_bullet5}) : '';
						itemAtt.custitem_web_bullet_uom_qty_info ? bullets.push({name: itemAtt.custitem_web_bullet_uom_qty_info}) : '';
						
						// TODO: Add validation to push tab
						details.push({
							name: item_information.name,
							bullets: bullets,
							content: content,
							itemprop: item_information.itemprop
						});
						
						if (!!itemAtt.custitem_tt_warning_message_ta) {
							details.push({
								name: "Warnings",
								warnings: itemAtt.custitem_tt_warning_message_ta
							});
						}

						// TODO: Add validation to push tab
						details.push({
							name: "Documents & Videos",
							isDocuments: true,
							content: content,
							sdsUrl: sdsUrl,
							sdsIsPdf: itemAtt.custitem_spe_msds,
							datasheetIsPdf: !itemAtt.custitem_spe_product_datasheet_url,
							datasheetUrl: datasheetUrl,
							manualIsPdf: !itemAtt.custitem_spe_product_manual_url,
							manualUrl: manualUrl,
							video: video
						});
					});
					
					return details;
				},
			});
			
			_.extend(QuantityPricingView.prototype,{
				initialize: _.wrap(QuantityPricingView.prototype.initialize, function (fn, options) {
					var ret = fn.apply(this, _.toArray(arguments).slice(1));
					this.template = tavanoteam_product_views_price_tpl;
					return ret;
				}),
			})

			_.extend(HeaderMiniCartItemCellView.prototype,{
				getContext: _.wrap(HeaderMiniCartItemCellView.prototype.getContext, function (fn, options) {
					var ret = fn.apply(this, _.toArray(arguments).slice(1));
					ret.rateFormatted = this.model.get('amount_formatted');
					return ret;
				}),
			})

			_.extend(ProductDetailsFullView.prototype,{
				initialize: _.wrap(ProductDetailsFullView.prototype.initialize, function (fn, options) {
					var ret = fn.apply(this, _.toArray(arguments).slice(1));
					this.template = product_details_full_extension_tpl;
					return ret;
				}),

				getContext: _.wrap(ProductDetailsFullView.prototype.getContext, function (fn, options) {
					var ret = fn.apply(this, _.toArray(arguments).slice(1));
					var itemAtt = this.model.get('item').attributes;
					var isHazardous = this.model.get('item').attributes.custitem_hazmat_un_number != "" ? true : false;
					var bulletZero = !!itemAtt.custitem_web_bullet0 ? itemAtt.custitem_web_bullet0 : false;
					var isMadeToOrder = this.model.get('item').get('custitem_tt_made_to_order')? true : false;
					
					ret.madeToOrderDisclaimerMessage = madeToOrderDisclaimerMessageEnable && isMadeToOrder ? madeToOrderDisclaimerMessage : false;
					ret.vendorname = itemAtt.vendorname ? itemAtt.vendorname : ''; // Manufacturer Part No:
					ret.manufacturer = itemAtt.custitem_attr_manufacturer ? itemAtt.custitem_attr_manufacturer : ''; // Manufacturer
					ret.units = itemAtt.custitem_web_bullet_uom_qty_info ? itemAtt.custitem_web_bullet_uom_qty_info : ''; // Units
					
					ret.minimumQuantity = itemAtt.custitem_spe_moq || false;
					console.log('ret.minimumQuantity', ret.minimumQuantity);
					ret.orderAndProductPoliciesMessage = orderAndProductPoliciesPDPMessage ? orderAndProductPoliciesPDPMessage : false;

					ret.isHazardous = isHazardous;
					ret.hazmatDisclaimerPDPMessage = hazmatDisclaimerPDPMessage;
					ret.bulletZero = bulletZero;
					return ret;
				}),
			})
			_.extend(ProductDetailsQuickView.prototype,{
				initialize: _.wrap(ProductDetailsQuickView.prototype.initialize, function (fn, options) {
					var ret = fn.apply(this, _.toArray(arguments).slice(1));
					this.template = product_details_quickview_extension_tpl;
					return ret;
				}),

				getContext: _.wrap(ProductDetailsQuickView.prototype.getContext, function (fn, options) {
					var ret = fn.apply(this, _.toArray(arguments).slice(1));
					var itemAtt = this.model.get('item').attributes;
					var isHazardous = this.model.get('item').attributes.custitem_hazmat_un_number != "" ? true : false;
					var isMadeToOrder =this.model.get('item').get('custitem_tt_made_to_order')? true : false;

					ret.madeToOrderDisclaimerMessage = madeToOrderDisclaimerMessageEnable && isMadeToOrder ? madeToOrderDisclaimerMessage : false;

					ret.minimumQuantity = itemAtt.custitem_spe_moq || false;
					ret.manufacturerPartNo = itemAtt ? itemAtt.vendorname : "";
					ret.manufacturer = itemAtt ? itemAtt.custitem_attr_manufacturer : ""; // Manufacturer
					ret.units = itemAtt ? itemAtt.custitem_web_bullet_uom_qty_info : ""; // Units
					ret.isHazardous = isHazardous
					ret.hazmatDisclaimerPDPMessage = hazmatDisclaimerPDPMessage
					return ret;
				}),
			});
		}
	};
});
